import { RealtorRewardsTheme } from '@jaymathew/ui-shared/elements/ThemeRealtorRewards'
import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material'
import { ReactNode, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducerIndex'
import { getSelectedCompany } from 'shared/functions/selectedCompanyAccess'

interface LocalThemeWrapperProps {
  children: ReactNode
}

const LocalThemeWrapper = ({ children }: LocalThemeWrapperProps) => {
	const { darkTheme } = useSelector((state: AppState) => state.appSettings)
	const currentCompany = getSelectedCompany()

	const theme = useMemo(
		() => RealtorRewardsTheme(
			{ darkTheme, primaryColor: currentCompany?.color || '#66BB6A' },
		), [darkTheme, currentCompany?.color])

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<GlobalStyles
				styles={{
					':root': {
						// Expose theme colors as CSS variables (single source of truth)
						'--app-bg': theme.palette.background.default,
					},
					// Optional: ensure base elements use the variables
					'html, body, #root': {
						backgroundColor: 'var(--app-bg)',
						minHeight: '100%',
					},
				}}
			/>
			{children}
		</ThemeProvider>
	)
}

export default LocalThemeWrapper
